<section class="project-member-internal-invite-employee">
	<div class="mat-body-1 my-3 add-employee text-center">
		{{ 'projectMembers.invite.companyMembers.title' | translate }}
	</div>
	<button mat-flat-button color="accent" data-cy="invite-company-member" class="w-100" (click)="openMemberInviteDialog()">
		{{ 'projectMembers.invite.companyMembers.btnTxt' | translate }}
	</button>
</section>
